import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useAppSelector } from "appRedux/hooks"
import { updateCurrentItemIndex, updateCurrentItemInfo, updateWishListViewMode } from "appRedux/slices/wishListSlice"
import { ITEM, LIST } from "constants/index"
import { SWITCH_LIST_ITEM_VIEW_MODE } from "constants/events"
import { BottomSheetAction } from "types/general.types"
import useEventListener from "hooks/useEventListener"
import useWishList from "hooks/useWishList"
import useResolveCurrentItemIndex from "hooks/useResolveCurrentItemIndex"
import WishListView from "components/templates/WishListView"
import WishListSliderView from "components/templates/WishListSliderView"

type WishListPageTemplateProps = {
  moreButtonActions: BottomSheetAction[];
  listIsEmpty: boolean;
}

export default function WishListPageTemplate(props: WishListPageTemplateProps) {
  const { moreButtonActions, listIsEmpty = false } = props

  const wishListState = useAppSelector((state) => state.wishList)

  const { isFetching } = useWishList(listIsEmpty)

  const dispatch = useDispatch()

  useEventListener(document, SWITCH_LIST_ITEM_VIEW_MODE, switchListItemViewMode)

  useResolveCurrentItemIndex(wishListState?.listInfo?.listItems || [])

  useEffect(() => {
    if (wishListState?.listInfo?.listItems === null) {
      dispatch(updateWishListViewMode(LIST))
    }
  }, [wishListState?.listInfo])

  function switchListItemViewMode() {
    if (wishListState.viewMode === ITEM) {
      dispatch(updateWishListViewMode(LIST))
      dispatch(updateCurrentItemInfo(null))
      dispatch(updateCurrentItemIndex(-1))
    } else {
      switchToSliderViewMode()
    }
  }

  function switchToSliderViewMode() {
    if (!wishListState?.listInfo?.listItems) return
    const firstItem = wishListState?.listInfo?.listItems[0] || null
    dispatch(updateCurrentItemInfo({ ...firstItem, wishlists: [] }))
    dispatch(updateCurrentItemIndex(firstItem ? 0 : -1))
    dispatch(updateWishListViewMode(ITEM))
  }

  return (
    wishListState.viewMode === LIST ? <WishListView
        list={wishListState?.listInfo?.listItems || []}
        isLoading={isFetching}
      /> :
      <WishListSliderView
        list={wishListState?.listInfo?.listItems || []}
        moreButtonActions={moreButtonActions}
        showProgressBar={(wishListState?.listInfo?.listItems && wishListState?.listInfo?.listItems.length > 1) || false}
      />
  )
}
